// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__12lJh","itemTitle":"ClientEmergencyInfo_itemTitle__2pbXm","itemText":"ClientEmergencyInfo_itemText__3gNxG"};